<template>
  <div>
    <!-- 修改 -->
    <div
      v-if="pageType === 'companySettings'"
      style="margin-left: 0; z-index: 11; padding-bottom: 60px">
      <div class="breadcrumb-box" style="padding: 16px 30px 16px 16px">
        <div class="breadcrumb">
          <span class="first" @click="pageType = ''">企业管理</span>
          /
          <span class="last">{{ type === "add" ? "增加" : "修改" }}企业</span>
        </div>
        <el-button type="primary" size="mini" style="background-color: #3e7878;border-color: #3e7878" @click="handleCloseEdit">返回</el-button>
      </div>
      <div
        class="system-setting"
        :style="{ height: Cheight + 'px', overflowY: 'scroll' }">
        <div
          class="pagination-bg-white"
          style="
            background: #fff;
            padding: 15px;
            margin-bottom: 80px;
            margin: 0 16px;
          ">
          <template>
            <el-form
              :model="form"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              size="small">
              <p
                style="
                  font-size: 16px;
                  padding-bottom: 15px;
                  margin-bottom: 15px;
                  border-bottom: 1px solid #ebebeb;
                  font-weight: bold;
                ">
                基本信息
              </p>
              <el-form-item
                label="品牌名称："
                prop="brandName"
                label-width="300px">
                <el-input
                  v-model="form.brandName"
                  placeholder="请填写"
                  style="width: 50%"/>
              </el-form-item>
              <el-form-item
                label="运营企业："
                prop="brandOperation"
                label-width="300px">
                <el-input
                  v-model="form.brandOperation"
                  placeholder="请填写"
                  style="width: 50%"/>
              </el-form-item>
              <el-form-item
                label="联系人："
                prop="brandContactPerson"
                label-width="300px">
                <el-input
                  v-model="form.brandContactPerson"
                  placeholder="请填写"
                  style="width: 50%"/>
              </el-form-item>
              <el-form-item
                label="联系方式："
                prop="brandContactMobile"
                label-width="300px">
                <el-input
                  v-model="form.brandContactMobile"
                  maxlength="11"
                  placeholder="请填写"
                  style="width: 50%">
                </el-input>
              </el-form-item>
              <el-form-item
                label="联系地址："
                prop="brandAddress"
                label-width="300px">
                <el-input
                  v-model="form.brandAddress"
                  placeholder="请填写"
                  style="width: 50%"/>
              </el-form-item>
              <p
                style="
                  font-size: 16px;
                  padding: 15px;
                  margin-bottom: 15px;
                  border-bottom: 1px solid #ebebeb;
                  font-weight: bold;
                ">
                运营信息
              </p>
              <el-form-item
                label="工作时间"
                prop="officeHours"
                label-width="300px">
                <el-time-picker
                  is-range
                  v-model="form.officeHours"
                  range-separator="至"
                  start-placeholder="上班时间"
                  end-placeholder="下班时间"
                  placeholder="选择时间范围"
                  value-format="HH:mm"
                  format="HH:mm">
                </el-time-picker>
              </el-form-item>
              <el-form-item
                label="自行车颜色"
                prop="bikeColor"
                label-width="300px">
                <el-color-picker v-model="form.bikeColor"/>
              </el-form-item>
              <el-form-item
                label="电动车颜色"
                prop="eBikeColor"
                label-width="300px">
                <el-color-picker v-model="form.eBikeColor"/>
              </el-form-item>
              <el-form-item
                label="运维人员数量："
                prop="brandOperationNum"
                label-width="300px">
                <el-input
                  v-model="form.brandOperationNum"
                  placeholder="请填写"
                  style="width: 50%"/>
                <span
                  style="
                    margin-left: 8px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.25);
                  ">
                  人
                </span>
                <div style="display: flex" v-if="type === 'edit'">
                  <a
                    @click="onDownload('maintain_person')"
                    href="javascript:;"
                    class="green"
                    style="margin: 0 24px 0 0">
                    下载模版
                  </a>
                  <el-upload
                    v-show="checkUserAuth(4, 11)"
                    style="display: inline-block"
                    :limit="1"
                    :file-list="fileList3"
                    :action="'/api/company/upload?selfAreaId=' + selfAreaId"
                    :data="{
                      type: 'maintain_person',
                      brandId: detail.brandId,
                      userId: user.id,
                    }"
                    :headers="{ Authorization: authorization }"
                    :on-success="handleAvatarSuccess3"
                    :before-upload="beforeAvatarUpload3"
                    :on-remove="handleRemove3"
                    :on-preview="onPreview">
                    <template>
                      <a class="table-btn green" href="javascript:;">上传信息</a>
                    </template>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="品牌核定自行车数量："
                prop="brandBikeNum"
                label-width="300px">
                 <el-input
                  v-model="form.brandBikeNum"
                  placeholder="请填写"
                  style="width: 50%"/>
                <span
                  style="
                    margin-left: 8px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.25);">
                  辆
                </span>
                <div style="display: flex" v-if="type === 'edit'">
                  <a
                    @click="onDownload('bicycle_excel')"
                    href="javascript:;"
                    class="blue"
                    style="margin: 0 24px 0 0">
                    下载模版
                  </a>
                  <el-upload
                    v-show="checkUserAuth(4, 11)"
                    style="display: inline-block"
                    :limit="1"
                    :file-list="fileList4"
                    :action="'/api/company/upload?selfAreaId=' + selfAreaId"
                    :data="{
                      type: 'bicycle_excel',
                      brandId: detail.brandId,
                      userId: user.id,
                    }"
                    :headers="{ Authorization: authorization }"
                    :on-success="handleAvatarSuccess4"
                    :before-upload="beforeAvatarUpload3"
                    :on-remove="handleRemove4"
                    :on-preview="onPreview">
                    <template>
                      <a class="table-btn blue" href="javascript:;">上传信息</a>
                    </template>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="品牌核定电动车数量："
                prop="brandEBikeNum"
                label-width="300px">
                 <el-input
                  v-model="form.brandEBikeNum"
                  placeholder="请填写"
                  style="width: 50%"/>
                <span
                  style="
                    margin-left: 8px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.25);
                  ">辆</span>
                <div style="display: flex" v-if="type === 'edit'">
                  <a
                    @click="onDownload('electric_vehicle_excel')"
                    href="javascript:;"
                    class="blue"
                    style="margin: 0 24px 0 0">
                    下载模版
                  </a>
                  <el-upload
                    v-show="checkUserAuth(4, 11)"
                    style="display: inline-block"
                    :limit="1"
                    :file-list="fileList5"
                    :action="'/api/company/upload?selfAreaId=' + selfAreaId"
                    :data="{
                      type: 'electric_vehicle_excel',
                      brandId: detail.brandId,
                      userId: user.id,
                    }"
                    :headers="{ Authorization: authorization }"
                    :on-success="handleAvatarSuccess5"
                    :before-upload="beforeAvatarUpload3"
                    :on-remove="handleRemove5"
                    :on-preview="onPreview">
                    <template>
                      <a class="table-btn blue" href="javascript:;">上传信息</a>
                    </template>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="投放区域："
                prop="launchArea"
                label-width="300px">
                <w-areaid
                  v-model="form.launchArea"
                  :detail="{ areaId: form.launchArea }"
                  placeholder="请填写"
                  tips="注：指政府允许该企业集中投放的地点"/>
              </el-form-item>
              <el-form-item
                label="运营区域："
                prop="operationAreaId"
                label-width="300px">
                <w-areaid
                  v-model="form.operationAreaId"
                  :detail="{ areaId: form.operationAreaId }"
                  placeholder="请填写"
                  tips="注：指政府允许该企业的实际运营区域"/>
              </el-form-item>
              <el-form-item
                label="归属区域："
                prop="areaId"
                label-width="300px">
                <w-areaid
                  v-model="form.areaId"
                  :detail="{ areaId: form.areaId }"
                  placeholder="请填写"/>
              </el-form-item>
              <p
                style="
                  font-size: 16px;
                  padding: 15px;
                  margin-bottom: 15px;
                  border-bottom: 1px solid #ebebeb;
                  font-weight: bold;">
                证明信息
              </p>
              <el-form-item
                label="政府批文图："
                prop="brandApprovalUrl"
                label-width="300px">
                <el-upload
                  style="width: 600px"
                  :limit="1"
                  :file-list="fileList1"
                  :action="'/api/upload/commonUpload?selfAreaId=' + selfAreaId"
                  :data="{ type: 'government_approval' }"
                  :headers="{ Authorization: authorization }"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-remove="handleRemove"
                  :on-preview="handlePreview">
                  <template>
                    <a
                      class="table-btn blue"
                      href="javascript:;"
                      style="text-decoration: revert">
                      上传PDF文件
                    </a>
                    <span
                      style="
                        margin-left: 28px;
                        font-size: 12px;
                        color: rgba(0, 0, 0, 0.25);
                      ">
                      注：指政府允许该企业集中投放的地点
                    </span>
                  </template>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="其他证明材料："
                prop="otherUrl"
                label-width="300px">
                <el-upload
                  style="width: 600px"
                  :limit="1"
                  :file-list="fileList2"
                  :action="'/api/upload/commonUpload?selfAreaId=' + selfAreaId"
                  :data="{ type: 'supporting_materials' }"
                  :headers="{ Authorization: authorization }"
                  :on-success="handleAvatarSuccess2"
                  :before-upload="beforeAvatarUpload"
                  :on-remove="handleRemove2"
                  :on-preview="handlePreview">
                  <template>
                    <a
                      class="table-btn blue"
                      href="javascript:;"
                      style="text-decoration: revert">
                      上传文件
                    </a>
                    <span
                      style="
                        margin-left: 28px;
                        font-size: 12px;
                        color: rgba(0, 0, 0, 0.25);
                      ">
                      选填
                    </span>
                  </template>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>
          <div style="text-align: center; magin: 15px">
            <el-button @click="onEditCancel">取消</el-button>
            <el-button :loading="loading" @click="onEditSure" type="primary" style="background-color: #3e7878;border-color: #3e7878">
              {{ type === "add" ? "添加" : "保存" }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业信息 -->
    <div v-else>
      <div>
        <div class="layout-header" ref="searchBox">
          <div class="infor-layout-header">
            <span class="title">企业管理</span>
            <p>
              <el-button
                v-show="checkUserAuth(4, 12)"
                type="primary"
                size="small"
                @click="onAdd"
                style="background-color: #3e7878;border-color: #3e7878">
                添加企业
              </el-button>
              <el-button
                v-show="checkUserAuth(4, 43)"
                size="small"
                @click="onShowDialog(null, 'history')">
                更新记录
              </el-button>
            </p>
          </div>
        </div>
        <div style="height: 6rem"></div>
        <div class="pagination-bg-white layout-header">
          <w-table
            :height="tableViewHeight"
            width="100%"
            v-show="checkUserAuth(4, 14)"
            v-loading.body="tableLoading"
            :data-list="tableData"
            :columns="staticData.users.columns"
            :pageNo="formData.pageNum"
            :pageSize="formData.pageSize"
            :total="total"
            :bPagination="false"
            @pageNoChange="pageNoChange"
            @pageSizeChange="pageSizeChange">
            <template v-slot:cell="props">
              <span v-if="props.column.label === '序号'">
                {{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
              <span v-else-if="props.column.label === '品牌名称'">
                <span
                  @click="onShowDialog(props.row, 'show')"
                  class="cursor"
                  style="text-decoration: underline">
                  {{ props.row.brandName }}
                </span>
              </span>
              <span v-else-if="props.column.label === '运维人数'">
                <span
                  @click="onShowDialog(props.row, 'show')"
                  class="blue cursor">
                  {{ props.row.brandOperationNum }}
                </span>
              </span>
              <span v-else-if="props.column.label === '品牌核定自行车数'">
                <span
                  @click="onShowDialog(props.row, 'show')"
                  class="blue cursor">
                  {{ props.row.brandBikeNum }}
                </span>
              </span>
              <span v-else-if="props.column.label === '品牌核定电动车数'">
                <span
                  @click="onShowDialog(props.row, 'show')"
                  class="green cursor">
                  {{ props.row.brandEBikeNum }}
                </span>
              </span>
              <span v-else-if="props.column.label === '区域'">
                <span>{{
                  getAddressNameForArea(props.row.areaId, nationalArea)
                }}</span>
              </span>
              <span v-else-if="props.column.label === '联系方式'">
                <span>
                  {{ hidePhoneNumber(props.row.brandContactMobile) }}
                </span>
              </span>
              <span v-else-if="props.column.label === '操作'">
                <el-button
                  v-show="checkUserAuth(4, 12)"
                  size="mini"
                  @click="onEdit(props.row)">
                  修改
                </el-button>
                <el-button
                  v-show="checkUserAuth(4, 13)"
                  size="mini"
                  type="danger"
                  @click="onDel(props.row)"
                  >删除
                </el-button>
              </span>
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
          <div v-show="!checkUserAuth(4, 14)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
    <!-- 弹窗 - 更新记录 -->
    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="dialogWidth"
      :sureBtnText="sureBtnText"
      :isShowFooter="isShowFooter"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure">
      <template v-slot:content>
        <div class="dialog-content">
          <template v-if="type === 'show'">
            <text-list-slot>
              <ul>
                <li>
                  <span>品牌名称：</span>
                  <span>{{ detail.brandName }}</span>
                </li>
                <li>
                  <span>运营企业：</span>
                  <span>{{ detail.brandOperation }}</span>
                </li>
                <li>
                  <span>企业账户：</span>
                  <span>{{ detail.brandAccount }}</span>
                </li>
                <li>
                  <span>随机密码：</span>
                  <span>{{ detail.brandPassword }}</span>
                </li>
                <li>
                  <span>联系人：</span>
                  <span>{{ detail.brandContactPerson }}</span>
                </li>
                <li>
                  <span>联系方式：</span>
                  <span>{{ detail.brandContactMobile }}</span>
                </li>
                <li>
                  <span>联系地址：</span>
                  <span>{{ detail.brandAddress }}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>运维人数：</span>
                  <span>{{ detail.brandOperationNum }}
                    <i
                      v-show="checkUserAuth(4, 15)"
                      @click="onShowDialog2('brandOperationNum')"
                      class="blue ml8 cursor">
                    详情</i>
                  </span>
                </li>
                <li>
                  <span>自行车数：</span>
                  <span>
                    {{ detail.brandBikeNum }}
                    <i
                      v-show="checkUserAuth(4, 15)"
                      @click="onShowDialog2('brandBikeNum')"
                      class="blue ml8 cursor">详情</i>
                  </span>
                </li>
                <li>
                  <span>电动车数：</span>
                  <span>
                    {{ detail.brandEBikeNum }}
                    <i
                      v-show="checkUserAuth(4, 15)"
                      @click="onShowDialog2('brandEBikeNum')"
                      class="blue ml8 cursor">
                    详情
                  </i>
                  </span>
                </li>
                <li>
                  <span>投放范围：</span>
                  <span>{{ detail.launchAreaText }}</span>
                </li>
                <li>
                  <span>运营范围：</span>
                  <span>{{ detail.operationAreaIdText }}</span>
                </li>
                <li>
                  <span>归属范围：</span>
                  <span>{{ detail.areaIdText }}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>政府批文：</span>
                  <span
                    @click="downloadExcel(detail.brandApprovalUrl)"
                    class="text-decoration cursor">
                    {{ detail.brandApprovalName }}
                  </span>
                </li>
                <li>
                  <span>其他证明：</span>
                  <span
                    @click="downloadExcel(detail.otherUrl)"
                    class="text-decoration cursor">
                    {{ detail.otherName }}
                  </span>
                </li>
              </ul>
            </text-list-slot>
          </template>
          <template v-if="type === 'history'">
            <company-history
              typeName="companyHistory"
              :companyData="tableData"
            />
          </template>
        </div>
      </template>
    </w-dialog>
    <!-- w-dialog2 详情 -->
    <w-dialog
      ref="w-dialog2"
      :title="dialogTitle2"
      :width="dialogWidth2"
      :sureBtnText="sureBtnText2"
      :isShowFooter="isShowFooter2"
      @handleClose="handleClose2"
      @handleCloseRight="handleClose2"
      @onSure="onSure2">
      <template v-slot:content>
        <div class="dialog-content" v-if="subType">
          <el-button type="default" style="small；background-color: #3e7878;border-color: #3e7878;" @click="onExport">
            导出数据
          </el-button>
          <w-table
            v-loading.body="tableLoading2"
            :data-list="tableData2"
            :columns="staticData[subType].columns"
            :pageNo="formData2.pageNum"
            :pageSize="formData2.pageSize"
            :total="total2"
            :bPagination="needPagination2"
            @pageNoChange="pageNoChange2"
            @pageSizeChange="pageSizeChange2">
            <template v-slot:cell="props">
              <span v-if="props.column.label === '序号'">{{
                props.index + 1 + (formData.pageNum - 1) * formData.pageSize
              }}</span>
              <span v-else-if="props.column.label === '工作单位'">
                <span>{{
                  tableData.find(
                    (it) => Number(it.brandId) === Number(props.row.brandId)
                  )
                    ? tableData.find(
                        (it) => Number(it.brandId) === Number(props.row.brandId)
                      ).brandName
                    : ""
                }}</span>
              </span>
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
        </div>
      </template>
    </w-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
import staticData from './staticData.js'
import { mapGetters } from 'vuex'
import { operates } from '@/utils/const'
import {
  getFilterParams,
  downloadExcel,
  getAddressNameForArea,
  hidePhoneNumber
} from '@/utils/tools'
import TextListSlot from '@/components/Listbox/textListSlot.vue'
import CompanyHistory from '@/components/Listbox/companyHistory.vue'
import WAreaid from '@/components/Form/w-areaid-company'
import validate from '@/utils/validate'

export default {
  name: 'company',
  components: {
    WDialog,
    WTable,
    TextListSlot,
    CompanyHistory,
    WAreaid
  },
  data() {
    return {
      loading: false,
      pageType: '',
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 1,
      tableLoading: false,
      tableData: null,
      formData2: {
        pageNum: 1,
        pageSize: 10
      },
      total2: 1,
      tableLoading2: false,
      tableData2: null,
      type: '',
      subType: '',
      dialogTitle: '',
      dialogWidth: '60%',
      sureBtnText: '确定',
      isShowFooter: true,
      dialogTitle2: '',
      dialogWidth2: '60%',
      sureBtnText2: '确定',
      isShowFooter2: false,
      needPagination2: false,
      detail: null,
      searchData: null,
      form: {
        brandName: '',
        brandOperation: '',
        // userName: '',
        brandContactPerson: '',
        brandContactMobile: '',
        brandAddress: '',
        brandOperationNum: '',
        brandAreaBikeNum: '',
        brandAreaEleBikeNum: '',
        launchArea: '',
        operationAreaId: '',
        areaId: '',
        brandApprovalUrl: '',
        otherUrl: '',
        maintainPersonUrl: '',
        bicycleUrl: '',
        electricVehicleUrl: '',
        officeHours: ['08:30', '18:30'],
        bikeColor: '',
        eBikeColor: '',
        brandBikeNum: '',
        brandEBikeNum: '',
        maintainPersonFileName: ''
      },
      rules: {
        brandName: [
          {
            required: true,
            message: '请填写品牌名称',
            trigger: 'blur'
          }
        ],
        brandOperation: [
          {
            required: true,
            message: '请填写运营企业',
            trigger: 'blur'
          },
          {
            min: 2,
            message: '长度至少2个字符',
            trigger: 'blur'
          }
        ],
        userName: [
          {
            required: true,
            message: '请填写登录账号',
            trigger: 'blur'
          },
          {
            validator: this.validateUserName,
            trigger: 'blur'
          }
        ],
        brandContactPerson: [
          {
            required: true,
            message: '请填写联系人',
            trigger: 'blur'
          },
          {
            min: 2,
            message: '长度至少2个字符',
            trigger: 'blur'
          }
        ],
        brandContactMobile: [
          {
            required: true,
            message: '请填写联系方式',
            trigger: 'blur'
          },
          {
            min: 8,
            message: '长度至少8个字符',
            trigger: 'blur'
          }
        ],
        brandAddress: [
          {
            required: true,
            message: '请填写联系地址',
            trigger: 'blur'
          }
        ],
        brandOperationNum: [
          {
            required: true,
            message: '请填写运维人员数量',
            trigger: 'blur'
          },
          {
            validator: this.brandOperationNum,
            message: '运维人员数量不能为0',
            trigger: 'blur'
          }
        ],
        officeHours: {
          required: true,
          message: '请填写工作时间',
          trigger: 'change'
        },
        bikeColor: {
          required: true,
          message: '请选择自行车颜色',
          trigger: 'change'
        },
        eBikeColor: {
          required: true,
          message: '请选择电动车颜色',
          trigger: 'change'
        },
        brandBikeNum: [
          {
            validator: this.checkNum,
            message: '只能输入整数',
            trigger: 'blur'
          }
        ],
        brandEBikeNum: [
          {
            validator: this.checkNum,
            message: '只能输入整数',
            trigger: 'blur'
          }
        ],
        launchArea: [
          {
            required: true,
            message: '请选择投放区域',
            trigger: 'blur'
          }
        ],
        operationAreaId: [
          {
            required: true,
            message: '请选择运营区域',
            trigger: 'blur'
          },
          {
            validator: this.validatorOperationAreaId,
            message: '运营区域和归属区域必须完全一致',
            trigger: 'blur'
          }
        ],
        areaId: [
          {
            required: true,
            message: '请选择归属区域',
            trigger: 'blur'
          },
          {
            validator: this.validatorAreaId,
            message: '运营区域和归属区域必须完全一致',
            trigger: 'blur'
          }
        ],
        brandApprovalUrl: [
          {
            required: true,
            message: '请上传政府批文图',
            trigger: 'blur'
          }
        ]
      },
      dialogVisible: false,
      dialogImageUrl: '',
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      tableViewHeight: ''
    }
  },
  computed: {
    ...mapGetters([
      'nationalArea',
      'user',
      'selfAreaId',
      'authorization',
      'userSelfAreaId',
      'globaleSelfAreaId',
      'userLevel'
    ]),
    staticData() {
      return staticData
    },
    operates() {
      return operates
    },
    Cheight() {
      return window.innerHeight - 56 - 150
    }
  },
  watch: {
    'form.officeHours'(val) {
      if (val == null) {
        this.form.officeHours = ['08:30', '18:30']
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    },
    getAddressNameForArea(id, lists) {
      try {
        return getAddressNameForArea(id, lists)
      } catch (err) {
        console.log(err)
      }
    },
    hidePhoneNumber(number) {
      return hidePhoneNumber(number)
    },
    onExport() {
      alert(this.subType)
    },
    handleClose2() {
      this.subType = ''
      this.$refs['w-dialog2'].onCloseDialog()
    },
    onSure2() {
      console.log('onSure2')
    },
    onDownload(type) {
      let url = ''
      if (type === 'maintain_person') {
        url = 'commonFile/共享单车企业运维人员信息导入模版.xls'
      } else if (type === 'bicycle_excel') {
        url = 'commonFile/共享单车企业自行车车辆信息导入模版.xls'
      } else if (type === 'electric_vehicle_excel') {
        url = 'commonFile/共享单车企业电动车车辆信息导入模版.xls'
      }
      if (url) {
        downloadExcel(url)
      }
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          successFn && successFn.call(this)
        })
        .catch(() => {
          failFn && failFn.call(this)
        })
    },
    onEditCancel() {
      this.showConfirm('温馨提示', '你是否确定取消本次修改？', () => {
        this.handleCloseEdit()
      })
    },
    onEditSure() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.handleFormRole()
        } else {
          return false
        }
      })
    },
    handleFormRole() {
      const vm = this
      vm.loading = true
      const data = { ...this.form }
      if (data.officeHours[0] && data.officeHours[1]) {
        data.officeHoursStart = data.officeHours[0]
        data.officeHoursEnd = data.officeHours[1]
        delete data.officeHours
      }
      const params = {
        selfAreaId: this.selfAreaId
      }
      if (this.type === 'edit') {
        data.brandId = this.detail.brandId
      }
      Api.createEnterprise(data, params)
        .then((res) => {
          if (res.code === 200) {
            vm.$message.success(
              `企业${this.type === 'edit' ? '编辑' : '添加'}成功！`
            )
            vm.initData()
            vm.handleCloseEdit()
          } else {
            vm.$message.warning(res.message)
          }
          vm.loading = false
        })
        .catch(() => {
          vm.loading = false
        })
    },
    onAdd() {
      const vm = this
      if (vm.userLevel !== 2) {
        vm.$message.warning('请选择对应区域！')
        return false
      }
      Api.getBikeSum(this.selfAreaId).then((res) => {
        if (res.code === 200) {
          if (res.data.areaBikeNum + res.data.areaEleBikeNum == 0) {
            let path = '/CompanyManagement/sum/'
            if (this.selfAreaId) {
              path += this.selfAreaId
            }
            this.$router.push(path)
          } else {
            vm.type = 'add'
            vm.pageType = 'companySettings'
          }
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    onDel(item) {
      this.detail = item
      this.showConfirm(
        '温馨提示',
        '你是否确定删除“' + item.brandName + '”？',
        () => {
          this.handleDel()
        },
        () => {}
      )
    },
    handleDel() {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId,
        enterpriseId: this.detail.brandId,
        deletedBy: vm.user.id
      }
      Api.deleteEnterprise(params).then((res) => {
        if (res.code === 200) {
          vm.$message.success('企业删除成功！')
          vm.initData()
          vm.handleCloseEdit()
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    getCompanyDetail(item) {
      this.detail = item
      // 地区处理
      this.form.launchArea = item.launchArea
      this.form.operationAreaId = item.operationAreaId
      this.form.areaId = item.areaId

      this.form.brandName = item.brandName
      this.form.brandOperation = item.brandOperation
      // userName = item.
      this.form.brandContactPerson = item.brandContactPerson
      this.form.brandContactMobile = item.brandContactMobile
      this.form.brandAddress = item.brandAddress
      this.form.brandOperationNum = item.brandOperationNum
      this.form.brandAreaBikeNum = item.brandAreaBikeNum
      this.form.brandAreaEleBikeNum = item.brandAreaEleBikeNum
      this.form.brandApprovalUrl = item.brandApprovalUrl
      this.form.bikeColor = item.bikeColor
      this.form.eBikeColor = item.ebikeColor
      this.$set(this.form, 'officeHours', [item.officeHoursStart, item.officeHoursEnd])
      this.fileList1 = []
      if (item.brandApprovalUrl) {
        this.fileList1.push({
          name: item.brandApprovalName,
          url: item.brandApprovalUrl
        })
      }
      this.form.otherUrl = item.otherUrl
      this.form.brandBikeNum = item.brandBikeNum
      this.form.brandEBikeNum = item.brandEBikeNum
      this.fileList2 = []
      if (item.otherUrl) {
        this.fileList2.push({
          name: item.otherName,
          url: item.brandApprovalUrl
        })
      }
      this.form.maintainPersonUrl = item.maintainPersonUrl
      this.form.maintainPersonFileName = item.maintainPersonFileName
      this.fileList3 = []
      if (item.maintainPersonUrl) {
        this.fileList3.push({
          name: item.maintainPersonFileName,
          url: item.maintainPersonUrl
        })
      }
      this.form.bicycleUrl = item.bicycleUrl
      this.fileList4 = []
      if (item.bicycleUrl) {
        this.fileList4.push({
          name: item.bicycleFileName,
          url: item.bicycleUrl
        })
      }
      this.form.electricVehicleUrl = item.electricVehicleUrl
      this.fileList5 = []
      if (item.electricVehicleUrl) {
        this.fileList5.push({
          name: item.electricVehicleFileName,
          url: item.electricVehicleUrl
        })
      }
      this.type = 'edit'
      this.pageType = 'companySettings'
    },
    onEdit(item) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        brandId: item.brandId
      }
      Api.getBrandInfoById(params).then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.getCompanyDetail(res.data)
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    handleCloseEdit() {
      this.pageType = ''
      this.form.brandName = ''
      this.form.brandOperation = ''
      this.form.brandContactPerson = ''
      this.form.brandContactMobile = ''
      this.form.brandAddress = ''
      this.form.brandOperationNum = ''
      // this.form.brandAreaBikeNum = "";
      // this.form.brandAreaEleBikeNum = "";
      this.form.brandEBikeNum = ''
      this.form.brandBikeNum = ''
      this.form.launchArea = ''
      this.form.operationAreaId = ''
      this.form.areaId = ''
      this.detail = null
      this.fileList1 = []
      this.fileList2 = []
      this.fileList3 = []
      this.fileList4 = []
      this.fileList5 = []
    },
    changeRoleId(val) {
      this.$refs.ruleForm.validateField(['userName'], (emailError) => {
        if (!emailError) {
          console.log('验证通过!')
        } else {
          console.log('验证失败!')
          return false
        }
      })
    },
    validateUserName(rule, value, callback) {
      if (!validate.checkUppercase(value)) {
        callback(new Error('请输入合法的登录账号'))
      }
      callback()
    },
    brandOperationNum(rule, value, callback) {
      if (!Number(value)) {
        callback(new Error('运维人员数量不能为0'))
      }
      if (Number(value) < 0) {
        callback(new Error('运维人员数量不能为0'))
      }
      callback()
    },
    checkNum(rule, value, callback) {
      if (value) {
        if (!/^([0]|[1-9][0-9]*)$/.test(value)) {
          callback(new Error('请输入整数！'))
        } else {
          callback()
        }
      }
      callback()
    },
    //
    bikeNum(rule, value, callback) {
      if (value.indexOf('.') !== -1) {
        callback(new Error('请输入合法电动车数量'))
      }
      if (value < 0) {
        callback(new Error('请输入合法自行车数量'))
      }
      callback()
    },
    ebikeNum(rule, value, callback) {
      if (value.indexOf('.') !== -1) {
        callback(new Error('请输入合法电动车数量'))
      }
      if (value < 0) {
        callback(new Error('请输入合法电动车数量'))
      }
      callback()
    },
    //
    validatorOperationAreaId(rule, value, callback) {
      // 运营区域
      if (this.form.areaId !== value) {
        callback(new Error('运营区域和归属区域必须完全一致'))
      }
      callback()
    },
    validatorAreaId(rule, value, callback) {
      // 归属区域
      if (this.form.operationAreaId !== value) {
        callback(new Error('运营区域和归属区域必须完全一致'))
      }
      callback()
    },
    beforeAvatarUpload3(file) {
      const isXLSX = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ].includes(file.type)
      if (!isXLSX) {
        this.$message.error('上传模版只能是 .xls或.xlsx 格式!')
      }
      return isXLSX
    },
    beforeAvatarUpload(file) {
      const isPDF = ['application/pdf'].includes(file.type)
      if (!isPDF) {
        this.$message.error('上传政府批文图只能是 PDF 格式!')
        return false
      }
      const maxSize = 10 * 1024 * 1024 // 10MB 的文件大小限制
      if (file.size > maxSize) {
        this.$message.error('文件大小超过限制（最大10MB）')
        return false // 阻止文件上传
      }
      return true // 允许文件上传
    },
    handleAvatarSuccess3(res, file) {
      console.log(res, file)
      if (res.code === 200) {
        this.form.maintainPersonUrl = res.data.path || file.response.data.path
        this.form.maintainPersonFileName = res.data.originFileName
        this.$message.success('运维人员信息模版上传成功！')
      } else {
        this.$message.warning(res.message)
        this.$nextTick(() => {
          this.fileList3 = []
        })
      }
    },
    handleAvatarSuccess4(res, file) {
      console.log(res, file)
      if (res.code === 200) {
        this.form.bicycleUrl = res.data.path || file.response.data.path
        this.form.bicycleFileName = res.data.originFileName
        this.$message.success('自行车信息模版上传成功！')
      } else {
        this.$message.warning(res.message)
        this.$nextTick(() => {
          this.fileList4 = []
        })
      }
    },
    handleAvatarSuccess5(res, file) {
      console.log(res, file)
      if (res.code === 200) {
        this.form.electricVehicleUrl = res.data.path || file.response.data.path
        this.form.electricVehicleFileName = res.data.originFileName
        this.$message.success('电动车信息模版上传成功！')
      } else {
        this.$message.warning(res.message)
        this.$nextTick(() => {
          this.fileList5 = []
        })
      }
    },
    handleAvatarSuccess2(res, file) {
      console.log(res, file)
      if (res.code === 200) {
        this.form.otherUrl = res.data.path || file.response.data.path
        this.form.otherName = res.data.originFileName
        this.$message.success('材料上传成功！')
      } else {
        this.$message.warning(res.message)
        this.$nextTick(() => {
          this.fileList2 = []
        })
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file)
      if (res.code === 200) {
        this.form.brandApprovalUrl = res.data.path || file.response.data.path
        this.form.brandApprovalName = res.data.originFileName
        this.$message.success('政府批文文件上传成功！')
      } else {
        this.$message.warning(res.message)
        this.$nextTick(() => {
          this.fileList1 = []
        })
      }
    },
    handlePreview(file, fileList) {
      console.log(file, fileList)
      if (file && file.url) {
        downloadExcel(file.url)
      }
    },
    downloadExcel(url) {
      downloadExcel(url)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.form.brandApprovalUrl = ''
      this.form.brandApprovalName = ''
    },
    onPreview(file) {
      console.log(111, file)
      let path = null
      if (file.response && file.response.data && file.response.data.path) {
        path = file.response.data.path
      } else if (file.url) {
        path = file.url
      }
      if (path) {
        downloadExcel(path)
      }
    },
    handleRemove3(file, fileList) {
      console.log(file, fileList)
      this.form.maintainPersonUrl = ''
      this.form.maintainPersonFileName = ''
    },
    handleRemove4(file, fileList) {
      console.log(file, fileList)
      this.form.bicycleUrl = ''
      this.form.bicycleFileName = ''
    },
    handleRemove5(file, fileList) {
      console.log(file, fileList)
      this.form.electricVehicleUrl = ''
      this.form.electricVehicleFileName = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove2(file, fileList) {
      this.form.otherUrl = ''
      this.form.otherName = ''
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      let params = {}
      params.selfAreaId = this.selfAreaId
      params = getFilterParams(params)
      Api.getEnterpriseList(params).then((res) => {
        if (res.code === 200) {
          vm.tableData = res.data.lists
          vm.total = res.data.total
        } else {
          vm.$message.warning(res.message)
        }
        vm.tableLoading = false
        vm.calcView()
      })
    },
    onShowDialog2(type) {
      const vm = this
      // vm.subType = type
      let paramsType = ''
      if (type === 'brandOperationNum') {
        // 运维人数
        vm.dialogTitle2 = '运维人员信息'
        paramsType = 'maintain_person'
        if (this.detail.maintainPersonUrl) {
          downloadExcel(this.detail.maintainPersonUrl)
        } else {
          this.$message.warning('运维人员信息不存在！')
        }
      } else if (type === 'brandBikeNum') {
        // 核定自行车数
        vm.dialogTitle2 = '自行车信息'
        paramsType = 'bicycle_excel'
        if (this.detail.bicycleUrl) {
          downloadExcel(this.detail.bicycleUrl)
        } else {
          this.$message.warning('自行车信息不存在！')
        }
      } else if (type === 'brandEBikeNum') {
        // 核定电动车数
        vm.dialogTitle2 = '电动车信息'
        paramsType = 'electric_vehicle_excel'
        if (this.detail.electricVehicleUrl) {
          downloadExcel(this.detail.electricVehicleUrl)
        } else {
          this.$message.warning('电动车信息不存在！')
        }
      }
    },
    onShowDialog(item, type) {
      this.detail = item
      this.type = type
      if (type === 'textList') {
        this.dialogTitle = '账号信息'
        this.sureBtnText = '确定'
        this.isShowFooter = true
      } else if (type === 'add') {
        this.dialogTitle = '添加企业'
        this.sureBtnText = '添加'
        this.isShowFooter = true
      } else if (type === 'edit') {
        this.dialogTitle = '修改企业'
        this.sureBtnText = '保存'
        this.isShowFooter = true
      } else if (type === 'show') {
        if (!this.checkUserAuth(4, 46)) {
          return false
        }
        this.dialogTitle = '企业信息'
        this.sureBtnText = '保存'
        this.isShowFooter = false
        this.getAddress()
      } else if (type === 'history') {
        this.dialogTitle = '更新记录'
        this.isShowFooter = false
      }
      this.$refs['w-dialog'].onShowDialog()
    },
    getAddress() {
      const vm = this
      if (vm.detail && vm.detail.areaId) {
        // 归属区域
        const params = {
          areaId: vm.detail.areaId,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, 'areaIdText', '')
            if (res.data.province && res.data.province.areaName) {
              vm.detail.areaIdText += res.data.province.areaName
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.areaIdText += res.data.city.areaName
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.areaIdText += res.data.region.areaName
            }
          }
        })
      }
      if (vm.detail && vm.detail.operationAreaId) {
        // 运营范围
        const params = {
          areaId: vm.detail.operationAreaId,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, 'operationAreaIdText', '')
            if (res.data.province && res.data.province.areaName) {
              vm.detail.operationAreaIdText += res.data.province.areaName
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.operationAreaIdText += res.data.city.areaName
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.operationAreaIdText += res.data.region.areaName
            }
          }
        })
      }
      if (vm.detail && vm.detail.launchArea) {
        // 投放范围
        const params = {
          areaId: vm.detail.launchArea,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, 'launchAreaText', '')
            if (res.data.province && res.data.province.areaName) {
              vm.detail.launchAreaText += res.data.province.areaName
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.launchAreaText += res.data.city.areaName
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.launchAreaText += res.data.region.areaName
            }
          }
        })
      }
    },
    onSure() {
      if (this.type === 'textList') {
        this.handleClose()
      } else if (['edit', 'add'].includes(this.type)) {
        this.handleForm()
      }
    },
    handleForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (['edit'].includes(this.type)) {
            this.sysUserEdit()
          } else if (['add'].includes(this.type)) {
            this.sysUserAdd()
          }
        } else {
          return false
        }
      })
    },
    sysUserEdit() {
      this.form.id = this.detail.id
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.sysUserEdit(this.form, params).then((res) => {
        console.log(111, res)
      })
    },
    sysUserAdd() {
      const params = {
        selfAreaId: this.globaleSelfAreaId // this.selfAreaId
      }
      Api.sysUserAdd(this.form, params).then((res) => {
        console.log(222, res)
      })
    },
    handleClose() {
      this.detail = null
      this.type = ''
      this.dialogTitle = ''
      this.form.userName = ''
      this.form.name = ''
      this.form.phone = ''
      this.form.company = ''
      this.form.roleId = ''
      this.form.areaId = ''
      this.form.unavailableTime = ''
      this.form.idcardUrl = ''
      this.form.idcardBackUrl = ''
      this.$refs['w-dialog'].onCloseDialog()
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
    pageNoChange2(page) {
      this.formData2.pageNum = page
    },
    pageSizeChange2(size) {
      this.formData2.pageSize = size
    }
  }
}
</script>

<style lang="less">
.layout-header {
  margin: 16px;
  width: calc(100% - 50px);
}

.breadcrumb-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f5;
  padding: 16px 30px 0 16px;
}

.breadcrumb {
  background-color: #f0f2f5;
  // padding: 16px 0 0 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.45);

  .last {
    color: rgba(0, 0, 0, 0.85);
  }

  span {
    cursor: pointer;
  }
}

.system-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
  // overflow-y: scroll;
}

.dialog-content {
  .content-header {
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;

    .title {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 16px;
    }

    .author {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.45);

      span {
        margin-right: 32px;
      }
    }
  }

  .content-body {
    padding: 16px 0;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.45);
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  background-color: #3e7878;
  border-color: #3e7878;
}

.avatar-uploader-icon {
  font-size: 21px;
  color: #8c939d;
  width: 112px;
  height: 112px;
  line-height: 112px;
  text-align: center;
  color: rgba(0, 0, 0, 0.25);
}

.avatar-uploader-text {
  position: absolute;
  bottom: 18px;
  left: 39px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.avatar {
  width: 112px;
  height: 112px;
  display: block;
}
</style>
